import {DefaultMetaTags} from '@common/seo/default-meta-tags';
import {c, SiteFooter, SiteHeader} from './mrigl-shell';
import {TemplatesShowcase} from './templates-showcase';

export function TemplatesPage() {
  return (
    <div
      className="mrigl-landing min-h-screen"
      style={{background: c.bg, color: c.ink}}
    >
      <DefaultMetaTags />
      <SiteHeader />
      <main className="mrigl-main">
        <TemplatesShowcase variant="full" />
      </main>
      <SiteFooter />
    </div>
  );
}
